import {MakeDTO} from './makeDTO.interface';
import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface ModelDTO extends BaseIntDTO {
  makeId: number;
  modelName: string;
  make: MakeDTO;
}
